import { useEffect, useState } from 'react';
import { generatePath, useMatch, useNavigate } from 'react-router-dom';

import ROUTES from '../../../../routes';

const useOverviewCompaniesPanel = ({ customerId }: { customerId?: string }) => {
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState<'current' | 'removed'>(
    'current',
  );

  const navigate = useNavigate();

  const transactionsMatch = useMatch(
    generatePath(ROUTES.CUSTOMERS_INDIVIDUAL_OVERVIEW_COMPANIES, {
      customerId: customerId as string,
    }),
  );

  const handleClose = () => {
    setPanelIsOpen(false);

    setTimeout(() => {
      navigate(
        transactionsMatch
          ? generatePath(ROUTES.CUSTOMERS_INDIVIDUAL_OVERVIEW_TRANSACTIONS, {
              customerId: customerId as string,
            })
          : generatePath(ROUTES.CUSTOMERS_INDIVIDUAL_OVERVIEW_CARDS, {
              customerId: customerId as string,
            }),
      );
    }, 100);
  };

  useEffect(() => {
    setPanelIsOpen(true);
  }, []);

  return {
    panelIsOpen,
    selectedTab,
    setSelectedTab,
    handleClose,
  };
};

export default useOverviewCompaniesPanel;
